import { render, staticRenderFns } from "./HorseHistoryAssignments.vue?vue&type=template&id=a96e4e80&"
import script from "./HorseHistoryAssignments.vue?vue&type=script&lang=js&"
export * from "./HorseHistoryAssignments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports